/* Local dependencies */
import { UserStatus } from '../../types';

export enum UpdateUserForManagerActionTypes {
  UPDATE_USER_FOR_MANAGER = 'UPDATE_USER_FOR_MANAGER',
  UPDATE_USER_FOR_MANAGER_SUCCESS = 'UPDATE_USER_FOR_MANAGER_SUCCESS',
  UPDATE_USER_FOR_MANAGER_ERROR = 'UPDATE_USER_FOR_MANAGER_ERROR',
  RESET_ERROR = 'RESET_UPDATE_USER_FOR_MANAGER_ERROR',
  RESET_STATE_UPDATE_USER_FOR_MANAGER = 'RESET_STATE_UPDATE_USER_FOR_MANAGER',
}

export interface UpdateUserForManagerInput {
  id: string;
  status: UserStatus;
}

export interface UpdateUserForManagerRequest {
  type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER;
  input: UpdateUserForManagerInput;
}

export interface UpdateUserForManagerSuccess {
  type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_SUCCESS;
}

export interface UpdateUserForManagerError {
  type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_ERROR;
  error: Error;
}

export interface ResetUpdateUserForManagerError {
  type: UpdateUserForManagerActionTypes.RESET_ERROR;
}

export interface UpdateUserForManagerReset {
  type: UpdateUserForManagerActionTypes.RESET_STATE_UPDATE_USER_FOR_MANAGER;
}

export type UpdateUserForManagerAction =
  | UpdateUserForManagerRequest
  | UpdateUserForManagerSuccess
  | UpdateUserForManagerError
  | ResetUpdateUserForManagerError
  | UpdateUserForManagerReset;
